export enum HttpStatusCode {
    CONFLICT = 409,
    TIMEOUT = 408,
    CLIENT_ERROR = 400,
}

export enum ContentType {
    JSON,
    FORM,
}
